export default {
  menuTitle: 'Menu Management',
  userTitle: 'User Management',
  permissions: 'Permissions',
  authorizationSuccessful: 'Authorization successful',
  state: 'state',
  module: 'module',
  controller: 'Controller',
  permissionButton: 'Permission Button',
  age: 'age',
  role: 'role',
  email: 'email',
  phone: 'phone',
  rightsProfile: 'Rights Profile',
  authority: 'authority system',
  platform: 'operating system',
  stat: 'statistical system',
  ad: 'delivery system',
  cs: 'customer Service System',
  log: 'log system',
  create: 'create',
  update: 'update',
  delete: 'delete',
  detail: 'details',
  export: 'export',
  status: 'status',
  description: 'description',
  authorize: 'authorize',
};
